module.exports = __webpack_public_path__ + "ki.svg?84841933e626d7194ab99001eaffcca7";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/ki.svg
// module id = 1190
// module chunks = 0